export const sensorIdNameMap = {
  '54653V1751052': 'Løehei',
  '00000V1702751': 'Timenes',
  '97410V1751020': 'Sognefjell',
  '07242V1751122': 'Kvernås',
  '38270V1751420': 'Inntjore',
  '50741V1751361': 'Tjorekjærra',
  '37724V1707378': 'Risdal',
};
